import { LeadTimeFormat, SellingUnitOfMeasure } from '@snap-types/models/enums';
import type { QuoteBuilderStateType } from '@ui/features/quote-builder/types/state';
import type { QuoteBuilderInternalType } from '@ui/features/quote-builder/types/state/internal';
import { QuoteBuilderPartInsightsStateType } from '@ui/features/quote-builder/types/state/part-insights';

export const defaultInternalState = {
  rawFieldValues: {},
  teamCode: '',
  isLoading: false,
  isUpdating: false,
  dialog: null,
  partSearchColumns: [],
  issues: {},
  isIssueDrawerOpen: false,
  quoteLineConfiguratorSnapshot: null,
  showAllDiscountCodes: false,
  showAllMarketCodes: false,
  currentServerData: null,
  pendingServerData: null,
  lastSaveDateTime: null,
} as const satisfies QuoteBuilderInternalType;

export const defaultPartInsightsState: QuoteBuilderPartInsightsStateType = {};

export const defaultState: QuoteBuilderStateType = {
  ...defaultInternalState,

  siteUuid: '00000000-0000-4000-8000-000000000000' as string,
  teamUuid: '00000000-0000-4000-8000-000000000001' as string,

  decimalPlaces: 4,
  leadTimeFormat: LeadTimeFormat.NUMBER,
  productionDaysPerWeek: 7,
  transitDaysPerWeek: 7,
  planningDaysPerWeek: 7,

  editMode: 'edit',
  sentAt: null,
  uuid: '',
  rootQuoteUuid: '',
  currentAssignment: null,
  quoteId: '',
  versionUuid: '',
  versionCount: 0,
  alphaQuoteUuid: null,
  siteCode: '',
  customerId: null,
  customerIndustry: '',
  termsNetDays: null,
  priceStrategies: [],
  sellingUnitOfMeasure: SellingUnitOfMeasure.EA,
  showCostFieldsForFixedPriceStrategies: false,
  siteDiscountCodes: null,
  allDiscountCodes: null,
  siteMarketCodes: null,
  allMarketCodes: null,

  salesRepName: null,
  salesRepEmail: null,
  salesRepPhone: null,
  csrName: null,
  csrEmail: null,

  name: null,
  salesRepId: null,
  csrOid: null,
  contactName: null,
  contactEmail: null,
  contactPhone: null,
  address1: null,
  address2: null,
  city: null,
  state: null,
  postalCode: null,
  countryCode: null,
  specs: null,
  notes: null,
  daysUntilQuoteExpires: null,
  daysUntilExpectedWin: null,
  customerQuoteId: null,
  discountCode: null,
  marketCode: null,
  wonLossStatus: null,
  quantityRange: null,

  quoteLineUuids: [],
  quoteLines: {},

  documentIds: [],
  documents: {},
};
